import { jsxs as m, jsx as t } from "react/jsx-runtime";
import { aG as f, d as _ } from "../../vendor-CPVnY93G.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as p } from "../../utils/omitStyleRenderProps/index.js";
import { FieldDescription as x } from "../FieldDescription/index.js";
import { FieldError as h } from "../FieldError/index.js";
import { FieldLabel as j } from "../FieldLabel/index.js";
import { Input as F } from "../Input/index.js";
import '../../assets/index59.css';const b = "_textField_jtdjl_1", u = "_fieldControl_jtdjl_11", z = "_label_jtdjl_17", C = "_horizontal_jtdjl_21", W = "_fullWidth_jtdjl_40", l = {
  textField: b,
  fieldControl: u,
  label: z,
  horizontal: C,
  fullWidth: W
};
function P({
  label: o,
  description: i,
  errorMessage: r,
  type: d = "text",
  inputMode: a = "text",
  enterKeyHint: n = "enter",
  fullWidth: c = !1,
  horizontal: s = !1,
  ...e
}) {
  return /* @__PURE__ */ m(
    f,
    {
      ...p(e),
      type: d,
      inputMode: a,
      enterKeyHint: n,
      className: _(l.textField, {
        [l.fullWidth]: c,
        [l.horizontal]: s
      }),
      "data-component": "TextField",
      children: [
        /* @__PURE__ */ t(j, { className: l.label, children: o }),
        /* @__PURE__ */ t(F, { "aria-label": e["aria-label"], className: l.fieldControl }),
        /* @__PURE__ */ t(x, { children: i }),
        /* @__PURE__ */ t(h, { children: r })
      ]
    }
  );
}
export {
  P as TextField
};
